import { IMAGE } from '../constent/theme';

export const getVehicleYear = (vehicle) => {
    const date = vehicle?.first_registration_date || vehicle?.manufacturing_date;
    if (!date) return 'N/A';
    try {
        return new Date(date).getFullYear();
    } catch {
        return 'N/A';
    }
};

export const getVehicleImage = (vehicle, fallback = IMAGE.productPic1) => {
    if (vehicle?.images?.[0]?.url) {
        return vehicle.images[0].url;
    }
    return fallback;
};

export const formatVehiclePrice = (vehicle) => {
    if (!vehicle?.gross_price) return 'Prix sur demande';
    return `€${vehicle.gross_price.toLocaleString('fr-BE')}`;
};

export const getVehicleTitle = (vehicle) => {
    if (!vehicle) return '';
    const parts = [];
    if (vehicle.manufacturer_name) parts.push(vehicle.manufacturer_name);
    if (vehicle.model) parts.push(vehicle.model);
    if (vehicle.model_text) {
        const modelLower = (vehicle.model || '').toLowerCase().trim();
        const modelTextLower = vehicle.model_text.toLowerCase().trim();
        if (modelLower !== modelTextLower && !modelLower.includes(modelTextLower) && !modelTextLower.includes(modelLower)) {
            parts.push(vehicle.model_text);
        }
    }
    return parts.join(' ');
};

export const getVehicleVariantLabel = (vehicle) => {
    if (!vehicle) return '';
    return [vehicle.model_text, vehicle.submodel].filter(Boolean).join(' — ') || vehicle.model;
};
